import http from "../services/customAxios";

import SoapLoginCommand from "../soap/SoapLoginCommand";

// let url = "http://localhost:8080/cash/Authentication";
// let url = "https://wildfly.orbit.local/cash/Authentication";
// let url = `https://dev.ots13.com:443/cash/Authentication`;

export default {
  async login(payload) {
    let loginCommand = new SoapLoginCommand(payload);

    // console.log("LOGIN XML:");
    // console.log(loginXml);

    let resp = await http.post(
      "/cash/Authentication",
      loginCommand.generateMessage(),
      {
        crossDomain: true,
        headers: {
          SOAPAction: "/cash/Authentication",
        },
      }
    );

    return resp;
  },

  logout() {
    //NOTHING TO DO HERE SINCE BEING "LOGGED IN" IS REALLY ONLY KEEPING A BASE64 TOKEN AROUND . . .  WE SIMPLY DELETE THAT TOKEN WITH THE "SERVICE"
  },
  async currentUser() {
    //NOT SURE THIS IS A SERVER FUNCTION
  },
};

//<username xsi:type="xsd:string">17862173.adminMW</username>
//<password xsi:type="xsd:string">OrbitMania9</password>

//<username xsi:type="xsd:string">12388080.ots</username>
//<password xsi:type="xsd:string">OrbitMania9</password>
